import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import DraggableImage from './DraggableImage';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'auto',
    overflowX: 'hidden',
    overflowY: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    padding: theme.spacing(1),
  },
}));

const ImageGrid = ({
  data,
  dragEnabled,
  onItemClickHandler,
  cols,
  dataIndex,
}) => {
  const classes = useStyles();

  if (!data) data = [];

  let sliced;
  if (dataIndex > 0) {
    sliced = JSON.parse(JSON.stringify(data)).slice(0, 40 * dataIndex);
  } else {
    sliced = data;
  }

  return (
    <div className={classes.root}>
      <GridList spacing={10} cols={cols} className={classes.gridList}>
        {sliced.map((tile, index) => (
          <DraggableImage
            height={cols === 1 ? 'auto' : '190px'}
            dragEnabled={dragEnabled}
            key={`${tile.title}-${index}`}
            tile={tile}
            name={tile.title}
            onItemClickHandler={onItemClickHandler}
          />
        ))}
      </GridList>
    </div>
  );
};
export default ImageGrid;
